import React from "react";
import { Modal, Row, Typography } from "antd";
import { List, Avatar } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
import { AppRoutes } from "../../AppRoutes";

const { Text } = Typography;

const ConsultantsEntryAndExitDetailModal = ({
  isEntriesAndExitsModalVisible,
  handleModalCancel,
  newConsultants,
  newResignConsultants,
}) => {
  const { t } = useTranslation();

  const handleConsultantClick = (consultantId) => {
    window.open(AppRoutes.consultantById.createPath(consultantId), "_blank");
  };

  return (
    <>
      <Modal
        title={`${
          newResignConsultants
            ? t("home.consultantsModal.lastResigned")
            : t("home.consultantsModal.newConsultants")
        }`}
        open={isEntriesAndExitsModalVisible}
        onCancel={handleModalCancel}
        okButtonProps={{ style: { display: "none" } }}
        cancelText={t("home.consultantsModal.back")}
      >
        <Row style={{ marginBottom: "2rem" }}>
          <Text type="secondary">
            {newResignConsultants
              ? t("home.consultantsModal.descriptionResigned")
              : t("home.consultantsModal.descriptionJoined")}
          </Text>
        </Row>

        <div
          id="scrollableDiv"
          style={{
            height: 400,
            overflow: "auto",
            padding: "0 16px",
            border: "1px solid rgba(140, 140, 140, 0.35)",
          }}
        >
          <InfiniteScroll dataLength={5} scrollableTarget="scrollableDiv">
            <List
              dataSource={newConsultants}
              renderItem={(item) => (
                <List.Item key={item.id}>
                  <List.Item.Meta
                    avatar={<Avatar src={item.image} />}
                    title={
                      <Text
                        style={{
                          cursor: "pointer",
                          color: "var(--adnblue)",
                        }}
                        onClick={() => handleConsultantClick(item.id)}
                        onMouseEnter={(e) => {
                          e.target.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.textDecoration = "none";
                        }}
                      >
                        {item.name}
                      </Text>
                    }
                    description={item.email}
                  />
                </List.Item>
              )}
            />
          </InfiniteScroll>
        </div>
      </Modal>
    </>
  );
};

export default ConsultantsEntryAndExitDetailModal;
